import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import * as Sentry from '@sentry/react';
import usePreventNavigation from '../../../../hooks/usePreventNavigation';
import Price from '../../shared/Price';
import ProductLink from '../../shared/ProductLink';

const SuggestedProducts = ({ history }) => {
  // Prevent user from navigating away from this page
  usePreventNavigation(history, '/v3/suggested-products');

  const {
    shoot,
    shootProducts,
    suggestedProducts,
    suggestedProductsCopy,
    suggestedProductsLinkToIndex,
  } = useSelector((state) => state.shoot);
  const company = useSelector((state) => state.company);
  const copy = suggestedProductsCopy || {};

  const suggestedProductsCategoryProducts =
    shootProducts[suggestedProductsLinkToIndex]?.products || [];

  if (
    suggestedProducts?.length > 0 &&
    suggestedProductsCategoryProducts?.length === 0
  ) {
    console.log('Sentry should fire here');
    Sentry.captureMessage(
      `Event ${shoot.id} has a misconfigured suggested products category`,
    );
  }

  const suggestedProductsCategoryId =
    shootProducts?.[suggestedProductsLinkToIndex]?.id;

  const renderSuggestedProduct = (product) => {
    return (
      <li className="order-product-recs__product" key={`rec-${product.id}`}>
        <div className="order-product-recs__product__info clearfix">
          <div className="order-product-recs__product__name">
            {product.name}
          </div>
          <div className="order-product-recs__product__price">
            <Price product={product} />
          </div>
        </div>
        <img
          className="order-product-recs__product__image"
          src={product.image_thumbnail}
        />
        <div>{product.description}</div>
      </li>
    );
  };

  const renderProducts = () => {
    const products = suggestedProducts.map((product) => (
      <ProductLink key={`rec-link-${product.id}`} product={product}>
        {renderSuggestedProduct(product)}
      </ProductLink>
    ));

    return <ul className="clearfix">{products}</ul>;
  };

  return (
    <div className="order-product-recs">
      <div className="order-product-recs-container">
        {(copy.header || copy.subheader || copy.description) && (
          <div className="order-product-recs__copy">
            {copy.header && (
              <h3
                className="order-product-recs__header"
                dangerouslySetInnerHTML={{ __html: copy.header }}
              />
            )}
            {copy.subheader && (
              <div
                className="order-product-recs__subheader"
                dangerouslySetInnerHTML={{ __html: copy.subheader }}
              />
            )}
            {copy.description && (
              <div
                className="order-product-recs__description"
                dangerouslySetInnerHTML={{ __html: copy.description }}
              />
            )}
          </div>
        )}
        {renderProducts()}
        <div
          className="bnl-button--light-blue"
          onClick={() => {
            history.push('/v3/categories/' + suggestedProductsCategoryId);
          }}
        >
          {company?.name === 'strawbridge'
            ? 'More Add-ons'
            : 'More Add-ons, Novelties & Prints'}
        </div>
        <div
          className="bnl-button--dark-gray"
          onClick={() => {
            history.push('/v3/offers');
          }}
        >
          Shopping Home
        </div>
      </div>
    </div>
  );
};

SuggestedProducts.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
    block: PropTypes.func.isRequired,
  }).isRequired,
};

export default SuggestedProducts;
